import { type LinearConfiguration } from "~/features/configurator/Linear/models";
import { type LinearConfiguratorState } from "~/features/configurator/Linear/redux/types";
import { sendConfiguratorResetStep } from "~/features/configurator/common/api/configuratorCommandApi";
import { transform } from "~/features/configurator/Linear/linearDataTransformer";
import { ConfiguratorType } from "~/domains/configurator/types/ConfiguratorType";
import type { ConfiguratorCsticTarget } from "~/features/configurator/common/api/configuratorCommands";

export async function sendRailDataReset(
  linearState: LinearConfiguratorState,
  resetTargets?: ConfiguratorCsticTarget[],
): Promise<LinearConfiguration> {
  const response = await sendConfiguratorResetStep(linearState, resetTargets);
  return transform(response, ConfiguratorType.Rail, undefined);
}
